<template>
  <div class="blinds__wrapper" :class="{'blinds__wrapper--closed': blindsClosed}">
    <div class="blinds__control" @click="toggleBlinds" v-if="buttonEnabled">
      <img src="@/assets/curtains.svg" alt="" />
    </div>
    <div class="blinds__sheets"></div>
  </div>
</template>

<script>
export default {
  name: "Blinds",
  props: {
    modelValue: {
      type: Boolean,
    },
    buttonEnabled: {
      type: Boolean,
      default: true
    },
  },
  emits: ['update:modelValue', 'blinds-toggled'],
  computed: {
    blindsClosed() {
      return this.modelValue
    }
  },
  methods: {
    toggleBlinds() {
      const nextVal = !this.blindsClosed
      this.$emit('blinds-toggled', { isClosed: nextVal })
      this.$emit('update:modelValue', nextVal)
    }
  },
  data() {
  }
}
</script>

<style scoped lang="scss">
.blinds__wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: all 0.5s linear;
  top: 0;
  &.blinds__wrapper--closed {
    .blinds__sheets {
      left: 0;
    }
    .blinds__control {
      transition: all 0.5s linear;
      display: block !important;
      background: var(--ld-brand-primary);
    }
  }
}
.blinds__sheets {
  display: flex;
  height: 100%;
  position: relative;
  left: -100%;
  z-index: 18;
  backdrop-filter: blur(8px);
}
.blinds__sheet {
  background: linear-gradient(90deg, var(--ld-bg-secondary), var(--ld-border-default));
  border: 1px solid var(--ld-border-subtle);
  border-left: none;
  height: 100%;
  width: 20%;
}
.blinds__control {
  display: none;
  position: absolute;
  width: 30px;
  height: 30px;
  z-index: 25;
  right: 10px;
  top: 10px;
  padding: 5px;
  border-radius: 100%;
  cursor: pointer;
  border: 1px solid var(--ld-text-inverse);
  &:hover {
    background: color-mix(in srgb, var(--ld-bg-secondary) 20%, transparent);
  }
}
.blinds__chain {
  height: 80%;
  width: 100%;
  margin-top: 2px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.blinds__handle {
  width: 100%;
  height: 30px;
  border-radius: 60px;
  background: var(--ld-bg-secondary);
  border: 1px solid var(--ld-border-subtle);
  box-shadow: inset 0px 0px 3px 0px var(--ld-border-subtle);
}
.blinds__chain-circle {
  width: 6px;
  height: 6px;
  background: linear-gradient(0deg, var(--ld-border-subtle), var(--ld-bg-secondary));
  border-radius: 100%;
  margin-bottom: 3px;
  border: 1px solid var(--ld-border-subtle);
}
</style>
